import classnames from 'classnames';

import styles from './divider.module.scss';

type Props = {
    direction?: 'horizontal' | 'vertical';
};

const Divider = ({ direction = 'horizontal' }: Props) => (
    <div
        className={classnames(styles.divider, {
            [styles.vertical]: direction === 'vertical',
        })}
    />
);

export { Divider };
